import React, { useContext, useState } from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import Logo from '../../../assets/images/FullLogo.svg';
import Paper from '@mui/material/Paper';
import { SEND_PASSWORD_RESET } from './operations';
import SnackbarContext from '../../contexts/SnackbarContext';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { useMutation } from '@apollo/client';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.sizes.fullPageNoAppBar,
    ...theme.palette.primaryBackground,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  form: {
    height: '400px',
    width: '450px',
    padding: '45px',
    boxSizing: 'border-box',
  },
}));

const SendResetLink = () => {
  const classes = useStyles();
  const { setSnack } = useContext(SnackbarContext);

  const [email, setEmail] = useState('');

  const handleChange = (e) => {
    const { value } = e.target;
    setEmail(value);
  };

  const [sendPasswordReset] = useMutation(SEND_PASSWORD_RESET, {
    variables: {
      email,
      redirectUrl: `${window.location.origin}/reset-password`,
    },
    onCompleted: (data) => {
      setSnack({
        open: true,
        message: data.userSendPasswordResetWithToken.message,
        severity: 'success',
      });
    },
    onError: () => {
      setSnack({
        open: true,
        message: 'User does not exist.',
        severity: 'error',
      });
    },
  });

  return (
    <div className={classes.root}>
      <Paper className={classes.form}>
        <img id="logo" src={Logo} alt="Welligence-Logo" width="200px" height="75px" />
        <Typography variant="h4" style={{ margin: '30px 0 15px' }}>
          Password Reset
        </Typography>
        <Grid
          container
          direction="column"
          align="center"
          spacing={3}
          sx={{
            justifyContent: 'space-around',
          }}
        >
          <Grid align="center" size={12}>
            <TextField
              value={email}
              onChange={handleChange}
              fullWidth
              id="user_email"
              name="user[email]"
              label="Email"
              variant="filled"
            />
          </Grid>
          <Grid size={12}>
            <Button variant="contained" color="secondary" onClick={sendPasswordReset}>
              Submit
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default SendResetLink;
